import { z } from 'zod/v4';

export const RemoveOriginParamsSchema = z.object({
  /** A live transaction on the origin-country link. */
  transactionId: z.string().min(1).max(36),
});

export type RemoveOriginParams = z.infer<typeof RemoveOriginParamsSchema>;

export const RemoveOriginBodySchema = z.object({
  /** The trace the caller is on, answered after the removal. */
  meta: z.object({
    orderId: z.string().min(1),
    type: z.enum(['PURCHASE_ORDER', 'SALES_ORDER']),
  }),
});

export type RemoveOriginBody = z.infer<typeof RemoveOriginBodySchema>;

/** Error `code` of the 403 sent when the origin order is another company's. */
export const REMOVE_ORIGIN_ERROR_CODES = {
  INSUFFICIENT_RIGHTS: 'insufficient_rights',
} as const;
